import { cn } from "@scribenote/brian-design-system";

export const Kbd = ({
  tokens,
  className,
}: {
  tokens: string[];
  className?: string;
}) => (
  <span
    className={cn(
      "flex shrink-0 items-center gap-1 font-mono text-fine-print text-annotation",
      className,
    )}
  >
    {tokens.map((token, i) => (
      <kbd
        key={`${token}-${i}`}
        className="min-w-[1.25rem] rounded-paper border border-rule px-1 py-0.5 text-center"
      >
        {token}
      </kbd>
    ))}
  </span>
);
